const CheckoutSummaryPage = () => {
    const main = document.getElementById('checkout-summary');
    if (!main) {
        return;
    }

    const element = {
        container: $('#checkout-summary'),
        form: {
            email: $('#email'),
            password: $('#password'),
            passwordConfirmation: $('#password_confirmation'),
        },
        btnCreateAccount: $('#btn-create-account'),
        createAccountError: $('#create-account-error'),
        createAccountSuccess: $('#create-account-success'),
        createAccountLoader: $('#create-account-loader'),
    };

    element.btnCreateAccount.click(function (e) {
        e.preventDefault();

        const data = {
            email: element.form.email.val(),
            password: element.form.password.val(),
            passwordConfirmation: element.form.passwordConfirmation.val(),
            orderRef: element.container.data('ref'),
        };

        if (data.password !== data.passwordConfirmation) {
            element.createAccountError.children('ul').empty().append('<li>The passwords don\'t match</li>');
            element.createAccountError.show();

            return;
        }

        element.createAccountError.hide();
        element.createAccountLoader.show();
        $(this).prop('disabled', true);

        axios.post('/create-account', data)
            .then((response) => {
                element.createAccountLoader.hide();
                element.createAccountSuccess.show();
                element.form.password.val("");
                element.form.passwordConfirmation.val("");
                $(this).prop('disabled', false);

                setTimeout(function () {
                    document.location.reload();
                }, 3000);
            })
            .catch((error) => {
                element.createAccountLoader.hide();
                element.createAccountError.children('ul').empty();
                $(this).prop('disabled', false);

                if (error.response.status === 422) {
                    const {response: {data: {errors}}} = error;
                    const keys = Object.keys(errors);

                    keys.forEach((key) => {
                        element.createAccountError.children('ul').append(`<li>${errors[key][0]}</li>`);
                    });
                } else {
                    element.createAccountError.children('ul').append(`<li>${error.response.data.message}</li>`);
                }
                element.createAccountError.show();
            });
    });
};

$(() => {
    CheckoutSummaryPage();
});
